<template>
  <div class="virtual-account-container">
    <div
      v-if="!isCoins"
      class="current-type-container is-bank"
      @click="showPaymentSelecter = true"
    >
      <span class="type-category ocean-ui-typeCategory">
        <template v-if="curPrice.TRANS_AMOUNT">
          <em class="payment-sleect-icon select-money-icon"></em>
          {{ curPrice.TRANS_AMOUNT }}
          {{ curPayType ? curPayType.show_currency : '' }}
          <span class="get-text" style="margin: 0 5px">=</span>
          <span v-if="+curPrice.COIN">
            {{ parseInt(curPrice.COIN) }}
            <span style="margin: 0 5px">{{ directPayCoinName }}</span>
          </span>
          <span v-if="+curPrice.EXTRA_COIN">
            + {{ parseInt(curPrice.EXTRA_COIN) }}
            <span style="margin: 0 5px">{{ directPayExtraCoinName }}</span>
          </span>
          <span class="type-discount" v-if="curPrice.EXTRA_RATIO">
            {{ languages.gainPlus }}
            {{ ~~(curPrice.EXTRA_RATIO * 100) }}%
          </span>
        </template>
        <template v-else>請選擇匯款金額</template>
      </span>
      <Icon class="selected-type-icon"></Icon>
    </div>
    <div class="bank-tips-content" v-if="isCoins">
      <div class="bank-tips-content_title">
        請注意：匯款金額須與選擇金額保持一致才能正常獲取資源
      </div>
    </div>
    <div class="bank-tips-content" v-else>
      <div class="bank-tips-content_title">請注意：</div>
      <div>
        <p>1、銀行虛擬帳號儲值只能進行鑽石儲值哦</p>
        <p>2、匯款金額須與選擇金額保持一致才能正常獲取資源</p>
      </div>
    </div>
    <!-- 代币的底栏 -->
    <coins-submit-footer
      v-if="this.isCoins"
      :isBankPay="true"
      :coinsList="curPayType.price_list"
      :curCoins="curCoins"
      @updateCurCoins="updateCurCoins"
      @postOrder="postOrder"
    ></coins-submit-footer>
    <!-- 非代币的底栏 -->
    <div class="submit-container is-bank" v-else>
      <div class="detail-container is-bank">
        <div class="order-detail">
          <div class="order-detail-title">
            {{ languages.storeHasSelect }}：{{ originCoin
            }}<span style="margin: 0 5px">{{ directPayCoinName }}</span>
          </div>
          <div class="order-detail-price-info">
            <div class="order-detail-price">
              <p class="price">
                {{ languages.storeTotal }}：<span class="price-total"
                  >{{ curPrice.TRANS_AMOUNT }}
                  {{ curPayType ? curPayType.show_currency : '' }}</span
                >
              </p>
              <span class="extra" v-if="extraCoin > 0"
                >{{ languages.storeExtra }}：{{ extraCoin
                }}<span style="margin: 0 5px">{{
                  directPayExtraCoinName
                }}</span></span
              >
            </div>
            <Button
              pointClass="j-submit-nbtn"
              class="submit-btn normal-btn j-submit-nbtn"
              @click="postOrder"
              data-asyncbtn=""
            >
              獲取匯款帳號
            </Button>
          </div>
        </div>
      </div>
    </div>
    <bank-payment
      v-if="showPaymentSelecter"
      @closeSelecter="showPaymentSelecter = false"
      :curPayType="curPayType"
      :curPrice="curPrice"
      :pricesList="pricesList"
      :showChildSelector="showPaymentSelecter"
      @selectPrice="selectPrice"
      style="z-index: 1002"
      :directPayCoinName="directPayCoinName"
      :directPayExtraCoinName="directPayExtraCoinName"
    ></bank-payment>
    <PopupWindow
      @onCancel="handleJump"
      @onConfirm="handleJump"
      type="tips"
      v-if="showPopup"
      :languages="languages"
      :content="contentTips"
      class="bank-tip-popup"
    ></PopupWindow>
  </div>
</template>

<script>
import BankPayment from './BankPayment';
import CoinsSubmitFooter from '../coins/CoinsSubmitFooter';
import { LOAD_BANK_PRICES, POST_ORDER } from '@store/officialStore';
import { commonEmitUpload } from '../../../plugins/AnalyzePoint/index';
import { mapGetters, mapState } from 'vuex';
import globalConfig from '@utiles/officialStore/globalConfig';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
const isEmptyObj = obj => Object.keys(obj).length === 0;
export default {
  name: 'bankPay',
  props: {
    curPayType: {
      require: true
    },
    gameId: {
      require: true
    },
    serverId: {
      require: true
    },
    roleId: {
      require: true
    },
    roleName: {
      require: true
    },
    languages: {
      require: true
    },
    isCoins: {
      default: false
    }
  },
  data() {
    return {
      curPrice: {},
      curCoins: {},
      pricesList: [],
      showPaymentSelecter: false,
      originCoin: 0,
      extraCoin: 0,
      totalCoin: 0,
      showPopup: false,
      contentTips:
        '發票處理事宜：於匯款完成七日內，請至下方『操作說明』選擇發票處理方式，若逾期未選擇，發票將默認捐贈“社團法人台灣偵搜犬協會”不做他用。',
      virtualAccount: '',
      canPost: true
    };
  },
  computed: {
    ...mapState({
      zipCode: state => state.zipCode
    }),
    coinName() {
      return this.$store.state.coin_name;
    },
    ...mapGetters(['directPayCoinName', 'directPayExtraCoinName'])
  },
  created() {
    if (this.isCoins) {
      this.curCoins =
        this.curPayType?.price_list && this.curPayType?.price_list[0]
          ? this.curPayType?.price_list[0]
          : {};
    } else {
      this.initData();
    }
  },
  watch: {
    curPrice: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (this.isCoins) {
          return;
        }
        this.originCoin = +(newVal?.COIN || 0);
        this.extraCoin = +(newVal?.EXTRA_COIN || 0);
        this.totalCoin = this?.originCoin + this?.extraCoin;
      }
    }
  },
  methods: {
    initData() {
      this.$store
        .dispatch(LOAD_BANK_PRICES, {
          f_pay_type: this.curPayType?.f_pay_type,
          pay_type: this.curPayType?.pay_type,
          currency: this.curPayType?.currency,
          game_id: this.gameId,
          server_id: this.serverId
        })
        .then(res => {
          this.pricesList = res;
          this.curPrice = this.pricesList[0];
        })
        .catch(err => {
          this.$emit('showError', err);
        });
    },
    updateCurCoins(curCoins) {
      this.curCoins = curCoins;
    },
    postOrder() {
      if (isEmptyObj(this.isCoins ? this.curCoins : this.curPrice)) {
        this.$emit('showError', '請選擇匯款金額');
        return;
      }
      if (!this.canPost) {
        return;
      }
      commonEmitUpload('click-submit-btn-manual', {
        event: 'click-submit-btn-manual',
        newPage: true,
        type: 'click'
      });
      this.canPost = false;
      const params = {
        f_pay_type: this.curPayType?.f_pay_type,
        paytype: this.curPayType?.pay_type,
        gameId: this.gameId,
        serverId: this.serverId,
        currency: this.curPayType?.currency,
        roleId: this.roleId,
        roleName: this.roleName,
        ptCode: 'global', // 区分新旧提单
        zipCode: this.zipCode,
        cid: globalConfig.getHrefParamUndecode('cid') || '',
        scid: globalConfig.getHrefParamUndecode('scid') || '',
        ...getGlobalGetLinkParams()
      };
      this.isCoins &&
        Object.assign(params, {
          submitType: 2
        });
      this.$store
        .dispatch(POST_ORDER, params)
        .then(res => {
          this.canPost = true;
          this.showPopup = true;
          this.virtualAccount = res.data.virtual_account_info.virtual_account;
        })
        .catch(err => {
          this.canPost = true;
          this.$emit('showError', err.errmsg);
        });
    },
    selectPrice(price) {
      this.curPrice = price;
      this.$nextTick(() => {
        this.showPaymentSelecter = false;
      });
    },
    handleJump() {
      this.showPopup = false;
      this.$router.push({
        name: 'bankInfo',
        query: {
          amount: this.isCoins
            ? this.curCoins?.TRANS_AMOUNT
            : this.curPrice?.TRANS_AMOUNT,
          account: this.virtualAccount
        }
      });
    }
  },
  components: {
    BankPayment,
    CoinsSubmitFooter
  }
};
</script>

<style lang="scss" scoped>
.virtual-account-container {
  display: block;
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  cursor: auto;
}
.current-type-container {
  cursor: pointer;
  @psetbg ('child-channel-bg.png');
}
.select-bank-amount-button {
  display: block;
  position: relative;
  box-sizing: border-box;
  background: white;
  line-height: 40px;
  font-size: 30px;
  color: #de6262;
  white-space: nowrap;
}
.select-type-ico {
  cursor: pointer;
  @psetbg ('child-channel-ico.png');
}
.coin-detail {
  &_left {
    display: flex;
    justify-content: space-between;
  }
  &-title {
    line-height: 100%;
    font-weight: bolder;
    font-size: 24px;
    color: #414141;
  }
  &-info {
    line-height: 100%;
    font-weight: bolder;
    font-size: 24px;
    color: #414141;
  }
  &_right {
    margin-top: 6px;
    line-height: 100%;
    text-align: right;
    .coin-detail-title {
      margin-right: 10px;
      height: 40px;
      line-height: 40px;
      vertical-align: middle;
    }
  }
  &-total {
    display: inline-block;
    box-sizing: border-box;
    padding: 0 10px;
    border: 1px solid #c2edd6;
    width: 278px;
    height: 40px;
    background-color: white;
    line-height: 40px;
    vertical-align: middle;
    text-align: left;
    font-weight: bold;
    font-size: 24px;
    color: #de6263;
  }
}
.bank-tips-content {
  margin-top: 42px;
  padding-left: 40px;
  font-size: 20px;
  color: var(--channel-tip);
  &_title {
    line-height: 130%;
  }
  p {
    margin-top: 10px;
    line-height: 130%;
  }
}
.submit-container {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 10;
  box-sizing: border-box;
  padding: 0 36px;
  width: 100%;
  background: var(--submit-bg);
  font-size: 0;
}
.detail-container {
  display: block;
  float: left;
  position: relative;
  box-sizing: border-box;
  padding: 22px 0;
  width: 100%;
  height: 180px;
  &.coupon {
    height: 236px;
  }
}
.order-detail {
  &-title {
    display: inline-block;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    color: var(--submit-title);
  }
  &-price-info {
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
    .order-detail-price {
      font-size: 30px;
      color: var(--submit-discount);
      .discount-price {
        display: flex;
        font-weight: bold;
        .price-wrap {
          display: flex;
          flex-direction: column;
        }
        .discount-total {
          font-size: 41px;
        }
        .price-total {
          text-decoration: line-through;
          text-decoration-color: var(--submit-price-hua);
          font-size: 24px;
          color: var(--submit-price);
        }
      }
      .price {
        font-weight: bold;
        .price-total {
          font-size: 41px;
        }
      }
      .paytype-tip {
        margin-top: 10px;
        font-size: 20px;
        color: var(--submit-tip);
      }
      .extra {
        display: inline-block;
        margin-top: 10px;
        padding: 5px 10px;
        border: 1px solid var(--submit-extra-border);
        text-align: center;
        font-size: 20px;
        color: var(--submit-extra);
      }
    }
    .order-detail-right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .order-coupon {
        &-choose {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-bottom: 15px;
          padding: 5px 10px;
          border: 1px solid var(--submit-coupon-choose-border);
          font-size: 24px;
          color: var(--submit-coupon-choose);
          &-text {
            line-height: 30px;
          }
        }
        &-tip {
          margin-bottom: 15px;
          font-size: 20px;
          color: var(--submit-tip);
        }
        .highligh {
          color: var(--submit-coupon-unchoose);
        }
      }
    }
    .submit-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      background-size: cover;
      cursor: pointer;
      font-size: 24px;
      color: var(--submit-btn);
      @psetbg ('submit.png');
    }
  }
}
@media screen and (orientation: portrait) {
  .coin-detail {
    &_left {
      flex-direction: column;
    }
    &-info {
      margin-top: 12px;
    }
    &_right {
      display: flex;
      justify-content: space-between;
      margin-top: 16px;
    }
  }
}
.bank-tip-popup {
  ::v-deep .dialog-title {
    margin-top: 38px;
  }
}
@media screen and (orientation: landscape) {
  .submit-container {
    left: 50%;
    width: 1202px;
    transform: translateX(-50%);
  }
  .current-type-container {
    &.is-bank {
      margin-top: 10px;
    }
  }
  .submit-btn {
    display: flex;
    @psetbg ('submit-hen.png');
  }
}
</style>
